import ExclamationCircleFilled from '@ant-design/icons/ExclamationCircleFilled'
import { Tooltip } from 'antd'

export const mainNum = 10
export const BRAND_REF_PID = 310 // 品牌对应的属性ID

export const IS_PRE_SALE_UNSCHED = 0
export const IS_PRE_SALE_PRE_SALE = 'isPreSale'
export const IS_PRE_SALE_GROUP_SALE = 'isGroupPreSale'
export const IS_PRE_SALE_SKU_PRE_SALE = 'skuPreSale'

export const IS_PRE_SALE_OPTIONS = [
    {
        label: '非预售',
        value: IS_PRE_SALE_UNSCHED
    },
    {
        label: '定时预售',
        value: IS_PRE_SALE_PRE_SALE
    },
    {
        label: (
            <>
                时段预售
                <Tooltip title="选择时请确保您的店铺有时段预售的权限，否则会铺货失败">
                    <ExclamationCircleFilled className="gylColorGrayN6" style={{ marginLeft: 4 }} />
                </Tooltip>
            </>
        ),
        value: IS_PRE_SALE_GROUP_SALE
    },
    {
        label: 'sku预售',
        value: IS_PRE_SALE_SKU_PRE_SALE
    }
]

export const PROPERTY_VALUE_TYPE = [5, 6, 7, 8]

// 是否标品
export const SPU_CONTROL_STANDARD_TYPE = 1

// 属性输入样式
export const CONTROL_TYPE_INPUT = 0 // 可输入
export const CONTROL_TYPE_SELECT = 1 // 可选择结构 label value
